import React from 'react';
import { useNavigate } from 'react-router-dom';
import Products from './PopularProducts';

const NotFound = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate('/');
  };

  return (
    <>
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
      <h1 className="display-1 fw-bold text-danger">404</h1>
      <p className="fs-3">
        <span className="text-danger">Oops!</span> Page not found.
      </p>
      <p className="lead">The page you're looking for doesn't exist or was moved.</p>
   
    </div>
    
    <Products />
     </>
  );
};

export default NotFound;
